import { useSelector } from 'react-redux';

import { selectCashierConfiguration } from '@cashier/cashier-data-access';
import { CashierConfiguration } from '@cashier/cashier-model';

export const useCashierConfiguration = (): CashierConfiguration => {
  return useSelector(selectCashierConfiguration);
};
